// Fire-and-forget print audit logging. Never blocks or throws — a failed
// log write must never stop a label from printing. Test/calibration
// prints are never logged (callers simply don't invoke this for them).
import api, { withSite } from "@/lib/api";

export function logPrint(siteId, { product_name, label_type, method, copies, payload } = {}) {
  if (!siteId) return;
  api
    .post(
      "/print-logs",
      {
        product_name: product_name || "\u2014",
        label_type,
        method: method || "tecor",
        copies: Number(copies) || 1,
        payload: payload || null,
      },
      withSite(siteId),
    )
    .catch(() => {});
}
